import {
  COMMENTARY_REVIEW_ISSUE_CATEGORY_TITLES,
  CommentaryReviewOutput,
} from '@aloft/toolkit-shared';
import { Block, Flex, Typography } from '@aloft/toolkit-sui';

export const CommentaryReviewResults = ({ data }: { data: { review: CommentaryReviewOutput } }) => {
  const flags = data.review.status === 'success' ? data.review.output.flags : [];

  return (
    <Flex flexDirection="column" gap="16px">
      <Block
        padding="16px"
        borderRadius="8px"
        backgroundColor={flags.length > 0 ? 'alertWarningLight' : 'surface2'}
      >
        <Flex flexDirection="column" gap="6px">
          <Typography variant="h3">
            {data.review.status === 'error'
              ? 'Review failed'
              : flags.length > 0
                ? `${flags.length} flag${flags.length === 1 ? '' : 's'}`
                : 'No flags'}
          </Typography>
          <Typography variant="body1">
            {data.review.status === 'success' ? data.review.output.summary : data.review.message}
          </Typography>
        </Flex>
      </Block>

      {flags.map((flag, index) => (
        <Block
          key={`${flag.category}-${index}`}
          padding="16px"
          borderRadius="8px"
          backgroundColor="surface1"
          border="1px solid #e0e0e0"
        >
          <Flex flexDirection="column" gap="10px">
            <div>
              <Typography variant="h4">
                {COMMENTARY_REVIEW_ISSUE_CATEGORY_TITLES[flag.category]}
              </Typography>
            </div>
            <Typography variant="body2">{flag.description}</Typography>
            {flag.fields.length > 0 && (
              <Flex gap="6px" flexWrap="wrap">
                {flag.fields.map((field) => (
                  <Block
                    key={field}
                    padding="4px 8px"
                    borderRadius="12px"
                    backgroundColor="surface2"
                  >
                    <Typography variant="body2" color="textSecondary">
                      {field}
                    </Typography>
                  </Block>
                ))}
              </Flex>
            )}
          </Flex>
        </Block>
      ))}
    </Flex>
  );
};
